import React from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import 'pages/changePassword/_changePassword.scss';
import {useNavigate} from 'react-router-dom';
import {routes} from 'common';
import {toast} from 'react-toastify';
import {useDispatch, useSelector} from 'react-redux';
import {authExtraActions} from 'reduxStore/actions';
import {ComLoader} from 'components';

const validationSchema = Yup.object().shape({
  current_password: Yup.string().required('Current password is required'),
  new_password: Yup.string()
    .required('New password is required')
    .min(8, 'Password must be at least 8 characters')
    .matches(/[A-Z]/, 'Must include at least one capital letter')
    .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Must include at least one special character'),
  confirm_password: Yup.string()
    .required('Please re-enter your new password')
    .oneOf([Yup.ref('new_password'), null], 'Passwords must match'),
});

const initialValues = {
  current_password: '',
  new_password: '',
  confirm_password: '',
};

function ChangePassword() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {loading} = useSelector((state) => state.auth);
  const handleSubmit = (values) => {
    dispatch(authExtraActions.changePassword(values)).then((response) => {
      if (response.type === "auth/changePassword/fulfilled") {
        toast.success('Password changed successfully.');
        navigate(routes.PROFILE);
      }
    });
  };

  return (
    <div className="change-password-container">
      <h2 className="change-password-title">Set New Password</h2>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ touched, errors }) => (
          <Form className="custom-form">
            <div className="form-group">
              <label htmlFor="current_password">
                Current Password <span className="required">*</span>
              </label>
              <Field
                type="password"
                id="current_password"
                name="current_password"
                className={`form-control${touched.current_password && errors.current_password ? ' is-invalid' : ''}`}
              />
              <ErrorMessage name="current_password" component="div" className="error-message" />
              <div className="form-hint">Please enter your current password</div>
            </div>

            <div className="form-group">
              <label htmlFor="new_password">
                New Password <span className="required">*</span>
              </label>
              <Field
                type="password"
                id="new_password"
                name="new_password"
                className={`form-control${touched.new_password && errors.new_password ? ' is-invalid' : ''}`}
              />
              <ErrorMessage name="new_password" component="div" className="error-message" />
              <div className="form-hint">
                Your password must include 1 capital letter, be a minimum of 8 characters, and have at least 1 special character.
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="confirm_password">
                Re-enter new password <span className="required">*</span>
              </label>
              <Field
                type="password"
                id="confirm_password"
                name="confirm_password"
                className={`form-control${touched.confirm_password && errors.confirm_password ? ' is-invalid' : ''}`}
              />
              <ErrorMessage name="confirm_password" component="div" className="error-message" />
            </div>

            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? <ComLoader/> : 'Confirm'}
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default ChangePassword;